
import { Card, CardHeader, Divider, Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { fetchDoorStatus } from '../../action/depotsCommands';
import { Booking, Depot, DoorStatus } from '../../api/types';
import { makeDepotDetailsUrl } from '../../routes';
import { makeDoorStatusSelector } from '../../selector/depotsSelector';
import DoorListWidget from '../depotDetails/DoorListWidget';

const PREFIX = 'BookingDepot';

const classes = {
    doorOverviewWrapper: `${PREFIX}-doorOverviewWrapper`,
    doorListWrapper: `${PREFIX}-doorListWrapper`,
    header: `${PREFIX}-header`,
};

const StyledCard = styled(Card)((
    {
        theme,
    },
) => ({
    [`& .${classes.doorOverviewWrapper}`]: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },

    [`& .${classes.doorListWrapper}`]: {
        width: '100%',
        maxWidth: 500,
        margin: '0 auto',
        height: '130px',
    },
    [`& .${classes.header}`]: {
        fontSize: '40px',
    },
}));

interface BookingDepotProps {
    depot: Depot;
    depotId: string;
    depotName: string;
    doors: number[];
    booking: Booking;
}

const BookingDepot = (props: BookingDepotProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const doorStatus: DoorStatus | undefined = useSelector(makeDoorStatusSelector(props.depotId));
    // const depot = useSelector(makeDepotSelector(props.depotId));
    // const [openDoorWarningOpen, setOpenDoorWarningOpen] = useState<boolean>(false);
    // const [rebookCustomerDoorWarningOpen, setRebookCustomerDoorWarningOpen] = useState<boolean>(false);
    // const [currentlySelectedDoor, setCurrentlySelectedDoor] = useState<number>(-1);

    useEffect(() => {
        if (!doorStatus) {
            dispatch(fetchDoorStatus({ depotId: props.depotId }));
        }
    }, [props.depotId]);

    // const handleOpenDoor = () => {
    //     dispatch(openDoor({ depotId: props.depotId, doorNumber: currentlySelectedDoor }));
    //     setOpenDoorWarningOpen(false);
    //     setCurrentlySelectedDoor(-1);
    // };

    // const handleRebookCustomerDoor = () => {
    //     dispatch(rebookCustomerDoor({
    //         bookingId: props.booking.bookingNumber,
    //         depotId: props.depotId,
    //         doorNumber: currentlySelectedDoor,
    //     }));
    //     setRebookCustomerDoorWarningOpen(false);
    //     setCurrentlySelectedDoor(-1);
    // };
    

    const sortedDoors = useMemo(
        () => props.doors.sort((door1, door2) => door1 - door2),
        [props.doors],
    );

    return (
        <StyledCard className={'bg-background border-foreground border'}>
            <CardHeader
                title={(
                    <span
                        style={{ fontSize: '24px' }}
                    >
                        {props.depot.name}
                    </span>)}
                subheader={(
                    <Link
                        component={NavLink}
                        to={makeDepotDetailsUrl(String(props.depotId))}
                        children={t('common.change_to_depot_view')}
                        underline={'hover'}
                    />
                )}
            />
            <Divider className={'mb-0 h-0.5 bg-background'} />
            <Grid container={true} spacing={2}>
                <Grid item={true} xs={12} md={6} className={classes.doorListWrapper}>
                    {sortedDoors.map(doorNumber => (
                        <DoorListWidget 
                            depot={props.depot}
                            doorNumber={doorNumber}
                            bookingId={props.booking.id}
                            itemId={props.booking.items[0].id}
                            booking={props.booking}
                        />
                        // <DoorListItem
                        //     key={doorNumber}
                        //     doorNumber={doorNumber + 1}
                        //     doorStatus={doorStatus?.doors[doorNumber + 1]}
                        //     onOpenClick={() => showOpenDoorWarning(doorNumber + 1)}
                        // onRebookDoorClick={() => showRebookCustomerDoorWarning(doorNumber + 1)}
                        //     enableRebookDoor={true}
                        // />
                    ))}
                </Grid>
            </Grid>

            {/* <OpenDoorDialog
                open={openDoorWarningOpen}
                doorNumber={currentlySelectedDoor}
                depotName={props.depotName}
                onConfirm={handleOpenDoor}
                onCancel={() => setOpenDoorWarningOpen(false)}
            /> */}
        </StyledCard>
    );
};

export default BookingDepot;
